module.exports = __webpack_public_path__ + "img/symbol_herzschloss.a35208c.webp";